import React from 'react';
import './Spinner.css';
import Icon from '../Icon/Icon';

export default (props) => {
    return (
        <div className={`${"Spinner"}${props.className ? " " + props.className : ""}`}>
            <Icon name="spinner" className="icon-spin" />
        </div>
    );
}
